import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  House,
  PlusCircle,
  ChatCircleDots,
  Van,
  Lightbulb,
  MapTrifold,
  Headset,
  ShieldCheck,
  ClipboardText,
  Storefront,
} from "@phosphor-icons/react";
import { OtmLogo } from "@/components/common/OtmLogo";
import { ASSETS } from "@/lib/assets";
import { useCustomer } from "@/context/CustomerContext";

const NAV = [
  { to: "/", label: "Home", icon: House, end: true, testid: "nav-home" },
  { to: "/chat", label: "Chat", icon: ChatCircleDots, testid: "nav-chat" },
  { to: "/chat", label: "New Chat", icon: PlusCircle, testid: "nav-new-chat", newChat: true },
  { to: "/my-caravan", label: "My Caravan", icon: Van, testid: "nav-my-caravan" },
  { to: "/guides", label: "Tips & Guides", icon: Lightbulb, testid: "nav-guides" },
  { to: "/repairers", label: "Repair Network", icon: MapTrifold, testid: "nav-repairers" },
  { to: "/warranty", label: "Warranty Claim", icon: ShieldCheck, testid: "nav-warranty" },
  { to: "/claim-status", label: "Track My Claim", icon: ClipboardText, testid: "nav-claim-status" },
  { to: "/support", label: "Contact Support", icon: Headset, testid: "nav-support" },
  { to: "/dealer/login", label: "Dealer Portal", icon: Storefront, testid: "nav-dealer-login" },
];

export function SidebarContent({ onNavigate }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { newChat } = useCustomer();

  const handleClick = (item, e) => {
    if (item.newChat) {
      e.preventDefault();
      newChat();
      navigate("/chat", { state: { fresh: true } });
    }
    onNavigate?.();
  };

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="px-2 pb-8 flex justify-center shrink-0">
        <OtmLogo />
      </div>

      <nav className="flex flex-col gap-1.5 flex-1 min-h-0 overflow-y-auto">
        {NAV.map((item) => {
          const Icon = item.icon;
          const active = item.newChat
            ? false
            : item.end
            ? location.pathname === item.to
            : location.pathname.startsWith(item.to);
          return (
            <NavLink
              key={item.testid}
              to={item.to}
              end={item.end}
              onClick={(e) => handleClick(item, e)}
              data-testid={item.testid}
              className={`group relative flex items-center gap-3 rounded-xl px-4 py-3 transition-colors duration-200 ${
                active
                  ? "bg-[#73bf44] text-[#050505] font-semibold"
                  : "text-neutral-400 hover:text-white hover:bg-white/[0.04]"
              }`}
            >
              <Icon size={20} weight={active ? "fill" : "regular"} />
              <span className="text-[0.95rem]">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <div className="mt-6 flex flex-col items-center gap-2 pt-6 border-t border-neutral-800 shrink-0">
        <div className="relative">
          <div className="w-20 h-20 rounded-full border-2 border-[#262626] overflow-hidden">
            <img src={ASSETS.nick} alt="Nick" className="w-full h-full object-cover" />
          </div>
        </div>
        <div className="text-center">
          <div className="font-heading font-bold tracking-wide text-white text-sm">NICK</div>
          <div className="text-xs text-neutral-500">AI Technical Expert</div>
        </div>
        <div className="flex items-center gap-1.5 rounded-full bg-[#73bf44]/10 px-3 py-1 mt-1">
          <span className="w-2 h-2 rounded-full bg-[#73bf44] pulse-dot" />
          <span className="text-[0.65rem] font-bold tracking-widest text-[#73bf44]">ONLINE</span>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-between text-[0.65rem] text-neutral-600 shrink-0">
        <span className="font-mono">OTM TECH AI v2.0</span>
        <NavLink to="/admin" className="flex items-center gap-1 hover:text-neutral-400" data-testid="nav-admin-link">
          <ShieldCheck size={13} /> Admin
        </NavLink>
      </div>
    </div>
  );
}
